import { Type } from '@angular/core';
import { RadioButtonOptionModel } from '../../../Common/Forms/models/radio-button-option.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { DisplayElementModel } from './display-element.model';

export class RadioButtonsFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    useChartPrefColors: boolean;
    options: RadioButtonOptionModel[];
    dynamicComponentType: boolean = false;
    headingId: string;
    appearCondition: (displayElement: DisplayElementModel) => boolean;
    headingStyleClass: string;
    inSectionLabel: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        useChartPrefColors: boolean,
        options: RadioButtonOptionModel[],
        dynamicComponentType?: boolean,
        headingId?: string,
        appearCondition?: (displayElement: DisplayElementModel) => boolean,
        headingStyleClass?: string,
        inSectionLabel?: string,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.useChartPrefColors = useChartPrefColors;
        this.options = options;
        this.dynamicComponentType = dynamicComponentType;
        this.headingId = headingId;
        this.appearCondition = appearCondition;
        this.headingStyleClass = headingStyleClass;
        this.inSectionLabel = inSectionLabel;
    }
}
